// src/components/PrivateRoute.jsx
import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useFirebase } from '@/context/FirebaseContext';
import { useWorkflowDispatch } from '@/context/WorkflowContext';

const PrivateRoute = ({ children }) => {
  const { auth } = useFirebase();
  const { setWorkflowUser } = useWorkflowDispatch();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        setWorkflowUser({
          id: currentUser.uid,
          email: currentUser.email,
          name: currentUser.displayName || 'User',
        });
      } else {
        setUser(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [auth, setWorkflowUser]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-900 text-white">
        <div className="text-2xl font-bold">Loading...</div>
      </div>
    );
  }

  if (!user) {
    // Redirect to login, passing the current path to redirect back after login
    return <Navigate to="/login" state={{ redirectAfterLogin: location.pathname }} replace />;
  }

  if (!user.emailVerified) {
    return <Navigate to="/login" state={{ redirectAfterLogin: location.pathname }} replace />;
  }

  return children;
};

export default PrivateRoute;
